"use client"

import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react"
import { useSession } from "next-auth/react"
import { io, Socket } from "socket.io-client"

const MainApiSocketContext = createContext<Socket | undefined>(undefined)
const ConsumersSocketContext = createContext<Socket | undefined>(undefined)
interface WebSocketProviderProps {
  children: ReactNode
}
export function MainApiSocketProvider({ children }: WebSocketProviderProps) {
  const [socket, setSocket] = useState<Socket | undefined>(undefined)
  const { data: session } = useSession()

  useEffect(() => {
    if (session == null) return
    const organizationId = session?.organizationId
    const userId = session?.user?.id
    const newSocket = io(
      process.env.NEXT_PUBLIC_MAIN_API_SOCKET_IO_SERVER_URL as string,
      {
        query: { organizationId, userId },
        transports: ["websocket"],
      }
    )
    setSocket(newSocket)

    return () => {
      newSocket.close()
    }
  }, [session])

  return (
    <MainApiSocketContext.Provider value={socket}>
      {children}
    </MainApiSocketContext.Provider>
  )
}

export function ConsumersSocketProvider({ children }: WebSocketProviderProps) {
  const [socket, setSocket] = useState<Socket | undefined>(undefined)
  const { data: session } = useSession()

  useEffect(() => {
    if (session == null) return
    const organizationId = session?.organizationId
    const userId = session?.user?.id
    const newSocket = io(
      process.env.NEXT_PUBLIC_CONSUMERS_SOCKET_IO_SERVER_URL as string,
      {
        query: { organizationId, userId },
      }
    )
    setSocket(newSocket)

    return () => {
      newSocket.close()
    }
  }, [session])

  return (
    <ConsumersSocketContext.Provider value={socket}>
      {children}
    </ConsumersSocketContext.Provider>
  )
}

export const useMainApiSocket = () => useContext(MainApiSocketContext)
export const useConsumersSocket = () => useContext(MainApiSocketContext)
